import React, { useEffect } from 'react';
import cn from 'classnames';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles } from '@Managers/Redux/AppState/AppState';

//PANELS
import { BrandLogo, TimePanel, DemoModeInformation } from '..';

// BUTTONS
import { MenuButton, SoundButton } from '@UILayer/Buttons';

const BottomSection: React.FC<{}> = () => {
    useEffect(() => {}, []);
    const globalStyles = useAppSelector(getGlobalStyles);

    const containerCN = cn(styles.bottomSection_container, globalStyles.orientation, globalStyles.device, globalStyles.wcaMode, globalStyles.handMode);

    return (
        <div className={containerCN}>
            <div className={styles.bottomSection_offset}>
                <div className={styles.bottomSection_gameMode}>
                    <DemoModeInformation />
                </div>
                <div>
                    <TimePanel />
                </div>
            </div>

            <div className={styles.bottomSection}>
                <div className={styles.bottomSection_menu}>
                    <MenuButton />
                    <SoundButton />
                </div>

                <div className={styles.bottomSection_right}>
                    <BrandLogo />
                </div>
            </div>
        </div>
    );
};

export default BottomSection;
